let quotationMethods = {
    getModifiedQuotationList(list){
        let modified = [];
        let u = localStorage.getItem('user');
        if (u) {
            u = JSON.parse(u);
        }

        list.forEach(quotation => {
            if (!u.is_admin && !u.is_super_admin && quotation.quotations.employee_id !== u.employee_id) {

            } else {

                modified.push({
                    employee_name: quotation.quotations.employee_name,
                    client_name: quotation.client_name,
                    client_city: quotation.client_city,
                    client_state: quotation.client_state,
                    client_email: quotation.client_email,
                    quotation_amt: quotation.quotations.quotation_amt,
                    quotation_date: this.modifyDate(quotation.quotations.quotation_date),
                    current_status: quotation.quotations.current_status,
                    contact_person_name: quotation.contact_person_name,
                    contact_person_phone: quotation.contact_person_phone,
                    contact_person_email: quotation.contact_person_email,
                })
            }
        })

        return modified
    },
    modifyDate(date2){
        let date1 = new Date(date2)
        let date = date1.getDate()
        let mon = date1.getMonth() +1
        let year = date1.getFullYear()

        const addZero=(num)=>{
            return num>9?num:`0${num}`

        }

        return `${addZero(date)}-${addZero(mon)}-${addZero(year)}`
    }
}

export default quotationMethods

